var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "url(#paint0_linear_3428_733)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11C23.4547 11 23.8907 11.1806 24.2122 11.5021C24.5337 11.8236 24.7143 12.2596 24.7143 12.7143V21.2857H33.2857C33.7404 21.2857 34.1764 21.4663 34.4979 21.7878C34.8194 22.1093 35 22.5453 35 23C35 23.4547 34.8194 23.8907 34.4979 24.2122C34.1764 24.5337 33.7404 24.7143 33.2857 24.7143H24.7143V33.2857C24.7143 33.7404 24.5337 34.1764 24.2122 34.4979C23.8907 34.8194 23.4547 35 23 35C22.5453 35 22.1093 34.8194 21.7878 34.4979C21.4663 34.1764 21.2857 33.7404 21.2857 33.2857V24.7143H12.7143C12.2596 24.7143 11.8236 24.5337 11.5021 24.2122C11.1806 23.8907 11 23.4547 11 23C11 22.5453 11.1806 22.1093 11.5021 21.7878C11.8236 21.4663 12.2596 21.2857 12.7143 21.2857H21.2857V12.7143C21.2857 12.2596 21.4663 11.8236 21.7878 11.5021C22.1093 11.1806 22.5453 11 23 11Z",
    fill: "url(#paint1_linear_3428_733)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3428_733",
    x1: 1,
    y1: 22.5,
    x2: 44,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6FFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3428_733",
    x1: 11,
    y1: 23,
    x2: 35,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusImage);
export default __webpack_public_path__ + "static/media/plusImage.24acac066b3ef3dc0ad04f05960bb0e1.svg";
export { ForwardRef as ReactComponent };